<template>
   <div v-if="items.length > 0" class="col-md-12 col-xl-8">
      <label>Resumen del Pedido</label>
      <div class="mb-0 ">
         <table class="table  table-centered table-nowrap text-center">
            <thead class="thead-light">
               <tr>
                  <th></th>
                  <th>Ref.</th>
                  <th>Desc.</th>
                  <th style="width:70px">Uni.</th>
                  <th>PVP Uni.</th>
                  <th>Dto.</th>
                  <th>PVP Total</th>
               </tr>
            </thead>
            <tbody>
               <tr v-for="(item, index) in items" :key="index">
                  <td><i @click="borrarItem(index)" style="font-size: 20px; cursor: pointer;" class="bx bx-trash-alt"></i></td>
                  <td>{{ item.ref }}</td>
                  <td>{{ item.descr }}</td>
                  <td style="width:70px"><input v-model="item.uni" @blur="calcularItem(index)" type="number" class="form-control" style="width:70px;" /></td>
                  <td>{{ item.pvp | currency }}</td>
                  <td>{{ item.descuento }}%</td>
                  <td>{{ item.pvpTotal | currency }}</td>
               </tr>
            </tbody>
         </table>
      </div>
   </div>
</template>

<script>
   export default {
      name: 'Order-Summary-Widget',
      props: {
         items: {
            type: Array,
            default: function() {
            return [];
            }
         },
         sumaTotal: {
            type: Number,
            default: function() {
            return 0;
            }
         }
      },
      methods: {
         borrarItem(index) {
            this.$emit('ajusteSumaTotal', this.items[index].pvpTotal)
            this.items.splice(index, 1)
         },
         calcularItem(index) {
            this.items[index].pvpTotal = this.items[index].pvp.replace(',', '.') * (1 - this.items[index].descuento / 100) * this.items[index].uni
            this.$emit('ajusteUnidades')
         }
      }
   }
</script>